export default [
	{
		path: '/dataList/warningPushSetting',
		component: (resolve) => require(['../page.vue'], resolve),
		meta: {
			title: '预警推送设置',
			keepAlive: false,
		},
	},
]
